import type { ProductCatalogItem } from "@/features/products/types";
import { apiClient } from "@/lib/apiClient";

export type CreateProductPayload = {
  name: string;
  description?: string;
  price: number;
  currency: string;
  measurementUnit: string;
  measurementPrecision: number;
  typeCode?: string;
};

/** Every field is optional: the API leaves a missing one untouched. */
export type UpdateProductPayload = Partial<CreateProductPayload>;

export type DeletedProduct = {
  id: string;
  name: string;
  isDeleted: boolean;
  deletedAt: string | null;
  /** The recipe the deletion took down with the product, if it had one. */
  deletedRecipeId: string | null;
  deletedSupplyingCount: number;
};

export const PRODUCTS_KEY = "products";

export const listProducts = async (): Promise<ProductCatalogItem[]> => {
  const products = await apiClient.get<ProductCatalogItem[]>(PRODUCTS_KEY);
  return Array.isArray(products) ? products : [];
};

export const createProduct = (payload: CreateProductPayload): Promise<ProductCatalogItem> =>
  apiClient.post<ProductCatalogItem>(PRODUCTS_KEY, payload);

export const updateProduct = (id: string, payload: UpdateProductPayload): Promise<ProductCatalogItem> =>
  apiClient.put<ProductCatalogItem>(`products/${id}`, payload);

export const deleteProduct = (id: string): Promise<DeletedProduct> =>
  apiClient.delete<DeletedProduct>(`products/${id}`);
